/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GradeCount
 */
export interface GradeCount {
    /**
     * 
     * @type {number}
     * @memberof GradeCount
     */
    grade: number;
    /**
     * 
     * @type {number}
     * @memberof GradeCount
     */
    count: number;
}

/**
 * Check if a given object implements the GradeCount interface.
 */
export function instanceOfGradeCount(value: object): value is GradeCount {
    if (!('grade' in value) || value['grade'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GradeCountFromJSON(json: any): GradeCount {
    return GradeCountFromJSONTyped(json, false);
}

export function GradeCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): GradeCount {
    if (json == null) {
        return json;
    }
    return {
        
        'grade': json['grade'],
        'count': json['count'],
    };
}

export function GradeCountToJSON(json: any): GradeCount {
    return GradeCountToJSONTyped(json, false);
}

export function GradeCountToJSONTyped(value?: GradeCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grade': value['grade'],
        'count': value['count'],
    };
}

